/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".layer-details-pane{margin-top:10px;margin-left:17px}.layer-details-pane .layer-details:nth-child(1){width:60%}.layer-details-pane .layer-details:nth-child(2){width:35%}.loader{position:absolute;top:calc(50% - 42.5px);left:calc(50% - 36.5px)}.steps-container{width:100%;height:20px;border-bottom:1px solid #000;margin-bottom:15px}.steps-label{font-size:25px;padding:4px 4px 4px 0;background-color:#fff}"];
export { styles as styles };
